<!-- Off-screen render host: only the chart components mount here so their exact
     Chart.js images can be captured (getChartImages) and POSTed to the backend
     report. All other sections are built server-side. -->
<div class="pdf-report">
  <ng-container *ngIf="isPublic">
    <app-innovation-metrics-activity *ngFor="let ax of SIGNAL_AXES" [tabId]="tabId" [entityids]="entityids"
      [tab_name]="tab_name" [entity_data]="entityData" [printMode]="true" [lockedAxis]="ax">
    </app-innovation-metrics-activity>
  </ng-container>

  <app-innovation-activity-over-time *ngFor="let ax of ACTIVITY_AXES" [tabId]="tabId" [entityids]="entityids"
    [tab_name]="tab_name" [query]="query" [printMode]="true" [lockedAxis]="ax">
  </app-innovation-activity-over-time>
</div>
